'use strict';
define([
    'angular',
    'modules/access/signin-feedbear/signin-feedbear.controller',
],function(angular, SigninFeedbearController){
    var app = angular.module('access.signin-feedbear', []);
    app.controller('SigninFeedbearController', SigninFeedbearController);
    return app;
});
